import { Box } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { NodeProps } from 'reactflow'
import { BERTH_HEIGHT, metersToPixels } from '../../helpers/yard-view.utils'
import { BerthWithActions } from '../../models/yard-view.model'
import { WavePattern } from '../atoms/YardNodes/Berth/WavePattern'
import { BerthHeader } from '../molecules/BerthHeader'
import { FocusWrapper } from '../molecules/FocusWrapper'
import { RotatableNodeWrapper } from '../molecules/RotatableNodeWrapper'

export const BerthNode = observer(({ data }: NodeProps<BerthWithActions>) => {
  const {
    id,
    name,
    bollards,
    quayMeterMarkFrom,
    quayMeterMarkTo,
    maxDraft,
    isEditable,
    focused,
    showNodeHeaders,
    layoutPosition,
    onEdit,
    onFocus,
    onDelete,
    onRotate,
  } = data

  return (
    <Box sx={{ position: 'relative', userSelect: 'none' }}>
      <RotatableNodeWrapper
        rotation={layoutPosition.rotation}
        enabled={focused && isEditable}
        onRotationEnd={angle => onRotate(id, angle)}
        header={
          focused || showNodeHeaders ? (
            <BerthHeader
              id={id}
              name={name}
              maxDraft={maxDraft ?? 0}
              quayMeterMarkFrom={quayMeterMarkFrom}
              quayMeterMarkTo={quayMeterMarkTo}
              bollardsCount={bollards?.length ?? 0}
              focused={focused}
              isEditable={isEditable}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ) : undefined
        }
      >
        <FocusWrapper
          focused={focused}
          isEditable={isEditable}
          onFocus={() => onFocus(id)}
          height={BERTH_HEIGHT}
          width={metersToPixels(quayMeterMarkTo - quayMeterMarkFrom)}
        >
          <WavePattern />
        </FocusWrapper>
      </RotatableNodeWrapper>
    </Box>
  )
})
